/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import { useState } from 'react';
import { AiOutlineMail, AiOutlinePhone } from 'react-icons/ai';
import { FaMapMarkerAlt, FaWhatsapp } from 'react-icons/fa';
import branchData from './contactData';
import ContactItem from './ContactItem';
import Map from './Map';

function ContactUs() {
    const [activeIndex, setActiveIndex] = useState(0);
    const branch = branchData[activeIndex];

    const items = [
        {
            id: 'address',
            icon: <FaMapMarkerAlt />,
            heading: 'Office Address',
            text: branch.label,
            item1: branch.address,
            item2: null,
            link: branch.link,
        },
        {
            id: 'phone',
            icon: <AiOutlinePhone />,
            heading: 'Phone Number',
            text: branch.fax ? `Fax: ${branch.fax}` : 'Call us anytime',
            item1: branch.phone,
            item2: branch.fax ? `Fax: ${branch.fax}` : null,
            link: `tel:${branch.phone.replace(/[^0-9+]/g, '')}`,
        },
        {
            id: 'whatsapp',
            icon: <FaWhatsapp />,
            heading: 'WhatsApp',
            text: 'Message us on WhatsApp',
            item1: branch.whatsapp,
            item2: null,
            link: `https://wa.me/${branch.whatsapp.split('/')[0].replace(/[^0-9]/g, '')}`,
        },
        {
            id: 'email',
            icon: <AiOutlineMail />,
            heading: 'Email Address',
            text: 'Send us an email',
            item1: branch.email,
            item2: null,
            link: `mailto:${branch.email}`,
        },
    ];

    return (
        <section className="contact-page-wrap section-padding">
            <div className="container">
                {/* Branch tab selector */}
                <div className="row mb-40">
                    <div className="col-12">
                        <div
                            style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: '10px',
                                marginBottom: '32px',
                            }}
                        >
                            {branchData.map((b, i) => (
                                <button
                                    key={b.id}
                                    type="button"
                                    onClick={() => setActiveIndex(i)}
                                    style={{
                                        padding: '10px 22px',
                                        border: `2px solid ${activeIndex === i ? 'var(--color-primary, #f28a30)' : '#ddd'}`,
                                        background: activeIndex === i ? 'var(--color-primary, #f28a30)' : '#fff',
                                        color: activeIndex === i ? '#fff' : '#333',
                                        borderRadius: '4px',
                                        fontWeight: activeIndex === i ? 700 : 400,
                                        cursor: 'pointer',
                                        transition: 'all 0.2s',
                                        fontSize: '14px',
                                    }}
                                >
                                    {b.name}
                                    {b.id === 1 && (
                                        <span
                                            style={{
                                                marginLeft: '6px',
                                                fontSize: '11px',
                                                background: activeIndex === i ? 'rgba(255,255,255,0.3)' : '#f0f0f0',
                                                borderRadius: '3px',
                                                padding: '1px 6px',
                                            }}
                                        >
                                            Main
                                        </span>
                                    )}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Contact info cards for selected branch */}
                <div className="row">
                    {items.map((data) => (
                        <ContactItem
                            key={data.id}
                            heading={data.heading}
                            text={data.text}
                            icon={data.icon}
                            item1={data.item1}
                            item2={data.item2}
                            link={data.link}
                        />
                    ))}
                </div>

                {/* Map for selected branch */}
                <div className="row">
                    <div className="col-12 col-lg-12">
                        <div className="contact-map-wrap">
                            <Map src={branch.mapSrc} title={`${branch.name} location`} />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ContactUs;
